<template>
  <fieldset class="mb-3">
    <legend>{{ $t("js.backend.campaign_selector.template") }}</legend>
    <div class="mb-3">
      <label for="campaign_template_id" class="visually-hidden">
        {{ $t("js.backend.campaign_selector.template") }}
      </label>
      <select id="campaign_template_id" name="campaign[template_id]" v-model="selectedCopy" class="form-select">
        <option></option>
        <option v-for="template in templates" @click="selectedCopy = template.id" :value="template.id">{{ template.name }}</option>
      </select>
    </div>
    <div>
      <div v-if="selectedTemplate">
        <div class="my-2"><b>{{ $t("js.backend.campaign_selector.template_preview") }}</b></div>
        <div v-if="type === 'SMS'" class="p-3 bg-light border" style="width: 250px; border-radius: 10px">
          <div class="mb-3" style="white-space: pre-wrap;">{{ selectedTemplate.message }}</div>
          <div class="float-end mt-n3 mb-2 ms-2" v-tooltip="$t('js.tooltips.estimated_sms_parts')">
            {{ selectedTemplate.data.estimated_size }}
            <AVIcon icon="comment-alt" />
          </div>
        </div>
        <div v-else class="border rounded border p-3" style="max-height: 400px;overflow:auto">
          <b>{{ $t("js.backend.campaign_selector.subject") }}:</b> {{ selectedTemplate.subject }}<br>
          <hr>
          <div style="white-space: pre-wrap;" v-html="selectedTemplate.message"></div>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType, CampaignTemplate } from "@/types";

export default defineComponent({
  name: "CampaignTemplateSelector",
  props: {
    templates: {
      type: Array as PropType<CampaignTemplate[]>,
      default: null,
    },
    selected: {
      type: Number,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedCopy: this.selected,
    }
  },
  computed: {
    selectedTemplate() {
      if (this.selectedCopy === null) return null;
      return this.templates.find((t: CampaignTemplate) => t.id === this.selectedCopy);
    }
  }
});
</script>
